import { html } from "lit";

export const IconChevronUp = (width = 12, height = 8, customClass) => html`
  <svg
    width="${width}"
    height="${height}"
    fill="none"
    viewBox="0 0 12 8"
    class="${customClass}"
  >
    <path d="M1.70703 7.707L6.00003 3.414L10.293 7.707L11.707 6.293L6.00003 0.586001L0.293031 6.293L1.70703 7.707Z" fill="black"/>
  </svg>
`;

export const IconChevronDown = (width = 12, height = 8, customClass) => html`
  <svg
    width="${width}"
    height="${height}"
    fill="none"
    viewBox="0 0 12 8"
    class="${customClass}"
  >
    <path d="M10.293 0.29303L5.99997 4.58603L1.70697 0.29303L0.292969 1.70703L5.99997 7.41403L11.707 1.70703L10.293 0.29303Z" fill="black"/>
  </svg>
`;

export const IconSwiperArrow = (width = 32, height = 32) => html`
  <svg
    width="${width}" 
    height="${height}" 
    viewBox="0 0 32 32" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect x="31.5" y="31.5" width="31" height="31" rx="15.5" transform="rotate(-180 31.5 31.5)" fill="white"/>
    <rect x="31.5" y="31.5" width="31" height="31" rx="15.5" transform="rotate(-180 31.5 31.5)" stroke="#BFBFBF"/>
    <path d="M13.8496 9.5L19.9996 15.65C20.0474 15.6949 20.0856 15.7491 20.1116 15.8093C20.1377 15.8695 20.1511 15.9344 20.1511 16C20.1511 16.0656 20.1377 16.1305 20.1116 16.1907C20.0856 16.2509 20.0474 16.3051 19.9996 16.35L13.8496 22.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const IconAdded = (width = 17, height = 16) => html`
  <svg 
    width="${width}" 
    height="${height}" 
    viewBox="0 0 17 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <path d="M7.4837 10.3907L5.28837 8.19539L4.3457 9.13806L7.4837 12.2761L13.955 5.80473L13.0124 4.86206L7.4837 10.3907Z" fill="#2B4676"/>
  </svg>
`;

export const IconLock = (width = 32, height = 32) => html`
  <svg 
    width="${width}" 
    height="${height}" 
    viewBox="0 0 32 32" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect x="32" y="32" width="32" height="32" rx="16" transform="rotate(-180 32 32)" fill="white"/>
    <path d="M15.9993 9.33337C14.1613 9.33337 12.666 10.8287 12.666 12.6667V14.6667H11.9993C11.264 14.6667 10.666 15.2647 10.666 16V21.3334C10.666 22.0687 11.264 22.6667 11.9993 22.6667H19.9993C20.7347 22.6667 21.3327 22.0687 21.3327 21.3334V16C21.3327 15.2647 20.7347 14.6667 19.9993 14.6667H19.3327V12.6667C19.3327 10.8287 17.8373 9.33337 15.9993 9.33337ZM19.9993 16L20.0007 21.3334H11.9993V16H19.9993ZM13.9993 14.6667V12.6667C13.9993 11.564 14.8967 10.6667 15.9993 10.6667C17.102 10.6667 17.9993 11.564 17.9993 12.6667V14.6667H13.9993Z" fill="black"/>
  </svg>
`;
